import AbsModal from './AbsModal';
import {makeElement} from '../common/Utils.js';

/**
 * Toast main
 */
export default class Toast extends AbsModal{

    constructor(_type='toast'){
        super();
        this.type = _type;
    }

    template(){
        const temp = makeElement( `
        <div id="${this.options.id}" class="nc-modal nc-modal--${this.options.site} nc-modal--${this.options.position}" tabindex="-1">
            <div class="nc-modal__dialog${this.options.mobileFull? ` nc-modal__dialog--full`: ``}" role="document"> 
                <div class="nc-modal__content${this.options.mobileFull? ` nc-modal__content--full`: ``}">
                    <div class="nc-modal__header">
                        <div class="nc-modal__title">${this.options.title}</div>
                        <div class="nc-modal__body">${this.options.contents}</div>
                    </div>
                    <div class="nc-modal__footer"></div>
                </div>
            </div>
        </div>` );

        const footerBtnTmpl = makeElement( `
        ${this.options.useCancelBtn?`
            <button type="button" class="nc-modal__btn nc-modal__btn--sec">
                <span class="nc-modal__btn-text">${this.options.cancelBtnText}</span>
            </button>
        `:``}
        ${this.options.usePrimaryBtn?`
            <button type="button" class="nc-modal__btn nc-modal__btn--pri">
                <span class="nc-modal__btn-text">${this.options.primaryBtnText}</span>
            </button>
        `:``}
        ` );

        if(this.options.useCancelBtn || this.options.usePrimaryBtn) temp.querySelector('.nc-modal__footer').appendChild(footerBtnTmpl);
        return temp;
    }

    open(_options={}){
        if (this.isShowModal) {
            this.close(false, true);
        }

        this.initialOptions.useBackdropClickClose = false;
        this.initialOptions.position = 'bottom';
        this.optionsSetting(_options);
        this.makeModalEl();
        this.setBtns();
        this.addEvents();

        super.open();
    }
    
    close(_result=true, _force=false){
        super.close(_result);
        if(_force){
            this.modalEl.parentNode.removeChild(this.modalEl);
        }else{
            setTimeout(() => {
                this.modalEl.parentNode.removeChild(this.modalEl);
            }, 100);
        }
    }


} // end of class
// TODO : 포지션 해결
// TODO : 등등